import React, { useState, useEffect, useContext } from 'react'
import './invoice.css'
import Layout from '../Layout'
import PropTypes from 'prop-types'
import Invoice from './Invoice'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import { Redirect, useParams, Link } from 'react-router-dom'
import DashboardHeader from '../DashboardLayout'
import AuthContext from '../../../Product/context/auth/authContext'
import DashboardLayout from '../DashboardLayout'
import Box from '@material-ui/core/Box'
import { useTranslation } from 'react-i18next'

const TabPanel = ({ children, value, index, ...other }) => {
    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `buyer-dashboard-${index}`,
        'aria-controls': `buyer-dashboard-tabpanel-${index}`,
    }
}

const SellerInvoice = (props) => {
    const [value, setValue] = useState(0)
    const authContext = useContext(AuthContext)
    const { user } = authContext
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    const { t } = useTranslation()
    const { page } = useParams()
    useEffect(() => {
        if (props.location.search) {
            setValue(parseInt(props.location.search.split('?page=')[1]))
        }
    }, [props])
    return (
        <Layout props={props}>
            <DashboardLayout title={t('payout')}>
                <div className="db-bids-wrapper">
                    <br></br>
                    {user?.card_profileid && parseInt(user?.verify_paypal) == 1 ? null : (
                        <h5 style={{ color: 'red' }}>
                            *Please Click <Link to="/dashboard/profile">here</Link> To Connect
                            Paypal Payout Account.
                        </h5>
                    )}
                    {/* <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="buyer-dashboard"
                        className="mt-4 liquidationDashTabs"
                    >
                        <Tab label={'Paid Invoices'} {...a11yProps(1)} />
                        <Tab label={'Unpaid Invoices'} {...a11yProps(0)} />
                    </Tabs>
                    <TabPanel value={value} index={0}> */}
                    <Invoice page="paid" />
                    {/* </TabPanel>
                    <TabPanel value={value} index={1}>
                        <Invoice page="unpaid" />
                    </TabPanel> */}
                </div>
            </DashboardLayout>
        </Layout>
    )
}

export default SellerInvoice
